<template>
      <div>
    <section style="background: #fff; padding: 40px; position: relative; display: block; min-height: 500px;">
        <div style="text-align: center;">
            <h2 style="margin-bottom: 0; font-size: 40px; font-weight: bold;">{{ block.title }}</h2>
            <img src="/img/teal-line.svg" style="margin: 20px 0;" />
        </div>
   
         <div v-for="(update, i) in block.VMblock" :key="i" style="margin-bottom: 20px;">
            <div>
                <div style="display: flex; align-items: center;">
                 
                     <p :style="{ 'color': update.vm.color, '--line-color': update.vm.color }" style="font-weight: bold; font-size: 24px; margin: 0 10px 0 0; white-space: nowrap;">
                        {{ update.vm.title }}
                    </p>
                 
                    
               
                    <div :style="{ 'background-color': update.vm.color }" style="flex-grow: 1; height: 2px;"></div>
             
                   
                    
                </div>
                <br/>
                <div class="fort-card-container" style="display: flex; width: 100%; align-items: flex-start;">
                    <div class="fort-body vm-content" style="padding-right: 20px; box-sizing: border-box; height: auto;" v-html="update.body"></div>
                    <div class="fort-body vm-card" style="padding: 20px; box-sizing: border-box; background: #F1F0F0; border-radius: 20px;">
                        <div style="text-align: center; margin-bottom: 15px;">
                          
                        
                            <img :src="'https://news.spacesaver.com' + update.vm.VMMheadshot.url" style="margin-left: auto; margin-right: auto;">
                  
                            
                           
                            
                        </div>
                        <div class="fort-body" v-html="update.vm.VMMtagline">
                           
                        </div>
                    </div>
                </div>

             
                 <div class="fort-body" v-if="update.footer" v-html="update.footer" :style="{ 'background-color': getFooterBackground(update.vm.color) }" style="padding: 40px; margin-top: 20px;"></div>
             
               
            </div>
        </div>
       
       
    </section>
  
   <divider v-if="block.BottomDivider" />
  </div>
</template>

<script>
  import Divider from "@/components/FortBuilder/Divider.vue";

export default {
    name: "VmUpdate",
    data() {
        return {
            updates: [
                {
                    market: "Military",
                    color: "rgba(227, 48, 29, 1)",
                    body: "<p>We are off to the best YTD start since 2019 – budgets are in full execution and units are spending money!</p><p><strong>Next Military Market Call</strong><br>June 27 at 1:30 PM CDT</p><p>The Air Force is the most active customer right now. Mission Support Groups within the Air Force make up more than half of ALL customer activity.</p><p>The following Army customers are moving to rapid deployment and agile maneuvering capabilities: Sustainment Brigades, Infantry Brigade Combat Teams, and Division Artillery Units. Ideal solutions to support these efforts include: Universal™ Expeditionary Weapons Storage System, Rapid Readiness Box, and Mobility Crate.</p>",
                    contact: { name: "Julio Asensio ", photo: "/img/Julio-Asensio.png", email: "" },
                    footer: ""
                },
                {
                    market: "Library & Higher Ed",
                    color: "rgba(233, 178, 26, 1)",
                    body: "<p>We're fresh off an action-packed (by invite only) Power 5 Conference featuring delegates from 60+ schools. Football was the main focus, but Olympic sports storage demand is increasing. What Power sports are in your PAR?</p><p><strong>Next Library/Education Market Call</strong><br>June 14 at 1:30 PM CDT</p><p>A busy few summer months of trade shows are upon us including the American Library Association (ALA) Conference and Society of American Archivists (SAA) Annual Meeting.</p>",
                    contact: { name: "Mark Haley", photo: "/img/Mark-Haley.png", email: "" },
                    footer: ""
                },
                {
                    market: "K-12",
                    color: "rgba(233, 178, 26, 1)",
                    body: "<p>Reminder that the end of fiscal year is typically June 30 for most districts, so it's a great time to make one last push and see if there is any leftover funding for projects.</p><p><strong>Next Library/Education Market Call</strong><br>June 14 at 1:30 PM CDT</p><p>OMNIA Partners has traditionally been one of our lesser used contracts. To help support increased use, OMNIA Partners will be holding a call on June 20 from 1:30 – 2:15 PM CDT, where attendees can learn more about the contract and ask questions on how and why we should leverage it. Reach out to Zak for more information.</p>",
                    contact: { name: "Mark Haley", photo: "/img/Mark-Haley.png", email: "" },
                    footer: ""
                },
                {
                    market: "Museum",
                    color: "rgba(159, 62, 167, 1)",
                    body: "<p>Many of our conversations at the 2024 American Alliance of Museums (AAM) Annual Meeting were geared toward our ability to offer consulting services from planning to delivery and beyond – a key differentiator from the competition.</p><p>The Society of American Archivists (SAA) Annual Meeting will be in Chicago August 14-17, and our team will be on hand to share the latest and greatest solutions in material preservation and protection.</p><p>Grant season is quickly approaching. Make sure your clients have all the information they need to secure these invaluable resources.</p>",
                    contact: { name: "Emily Martin", photo: "/img/Emily-Martin.png", email: "" },
                    footer: "<h6>Meet Your New Market Sales Manager</h6><p>Great news is worth telling multiple times. However, if this is your first time hearing it, we wanted to announce that Emily Martin has been promoted to Market Sales Manager – Museums. In this role, she'll drive thought leadership and market sales goals by continuing to build relationships and offer consultant services by applying detailed product application and design knowledge. Along with you – our network of dedicated storage experts – Emily will continue assisting in maximizing sales and profitability of Spacesaver product within the Museum market. In the past year, alongside our Distribution, Emily has helped the Major Projects team secure five large museum projects worth over $5 million net Spacesaver material. Her patience and persistence learning this market and the needs of its customers has allowed her to build a strategic, consultant-type skillset while promoting the value Spacesaver as a full solutions provider.</p>"
                },
                {
                    market: "Healthcare",
                    color: "rgba(146, 185, 54, 1)",
                    body: "<p>The life sciences sector is heating up as lab demand drives office to lab conversions. This is a great opportunity to display how our consultative approach can help them make the most of their space.</p><p>To date in 2024, fifteen hospital projects over $500 million have been announced, with eight more projected to cost more than $1 billion. The opportunities are out there; let us know how we can help you capture them.</p><p>Make sure to be on the lookout for monthly Healthcare Market Calls to begin in August!</p>",
                    contact: { name: "Steve Lane", photo: "/img/Steve-Lane.png", email: "" },
                    footer: ""
                },
                {
                    market: "Public Safety",
                    color: "rgba(29, 136, 206, 1)",
                    body: "<p>Spacesaver launched new digital lock options for FreeStyle® Personal Storage Lockers from Digilock and Ojmar to offer your customers a commercialized choice to fit every need.</p><p>We just finished up our first American Jail Association Conference in Ft. Lauderdale May 19-21, which included more than 900 attendees and 170 vendors.</p><p><strong>Next Public Safety Market Call</strong><br>July 18 at 10:30 AM CDT</p><p>For Public Safety and Corrections facilities looking for funding, the Edward Byrne Memorial Justice Assistance Grant (JAG) program is open in several SSC product categories. More to come on this…</p><p>OMNIA Partners will be holding a call on June 27 at 1:00 PM EDT, where attendees can learn more about the contract and ask questions on how and why we should leverage it. Reach out to Scott for more information.</p>",
                    contact: { name: "Scott Loreaux", photo: "/img/Scott-Loreaux.png", email: "" },
                    footer: "<h6>Solutions for Every Square Inch</h6><p>If you're looking for a great example of how the Spacesaver Group can provide proven storage solutions for just about anything in your PAR's Public Safety Facilities, Richard Chandler of Interior Solutions has one for you in the Mesa PD project he is facilitating. The installation, which will be wrapping up shortly, includes a wide array of solutions for storing materials in FIFTEEN different capacities from long-term storage to evidence lockers to weapons. This install is truly a testament to the one-of-a-kind consultative approach our nationwide representatives take in helping customers identify and address all their needs through Spacesaver's customizable solutions. Thank you, Richard, for sharing this project with the Group!</p>"
                }
            ]
        };
    },
    props: {
      block: {
        type: Object,
        required: true,
      },
    },
    components: {
        Divider,
    },
    methods: {
        getFooterBackground(color) {
            // Parse rgba(r, g, b, a) string
            const match = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*[\d.]+)?\)/);
            if (match) {
                const [, r, g, b] = match;
                return `rgba(${r}, ${g}, ${b}, 0.15)`; // Set alpha to 0.2 (20% opacity)
            }
            return color; // Fallback to original color if parsing fails
        }
    },
};
</script>

<style scoped>
/* No styles needed here, as inline styles handle the layout */
.vm-card {
    flex: 0 0 25%;
    padding: 20px;
    box-sizing: border-box;
    background: #F1F0F0;
    border-radius: 20px;
    /* No height or max-height to allow content-driven height */
}
.vm-card img {
    max-width: 100%;
    height: auto;
    margin-left: auto;
    margin-right: auto;
}

@media (min-width: 1200px) {
    .vm-content{
    flex: 0 0 70%;
    }
    .vm-card{
        flex: 0 0 30%; 
    }
}

@media (min-width: 992px) {
    .fort-card-container{
        flex-direction: row;
    }
}
@media (max-width: 991px) {
    .fort-card-container{
        flex-direction: column;
    }
    .vm-card{
        width: 100%;
        text-align: center;
    }
}

</style>